<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Billing History'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    <tidy-card>
      @if (item?.isPendingClientCharge) {
        <ion-chip [class]="item?.class">
          <ion-icon [name]="item?.icon" />
          <ion-label>{{ item?.status | titlecase }}</ion-label>
        </ion-chip>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text
            style="margin-right:5px"
            [header]="(item?.amount | tcurrency) + (' charge' | translate)" />
          <tidy-image
            style="margin-left: 5px; cursor: pointer"
            (action)="goToBillingItemHelp(item)"
            [src]="'assets/svg/help-circle-outline.svg'"
            class="header-size" />
          <tidy-text
            [body]="item?.formattedDate" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          @if (item?.payment_method?.type === 'card') {
            <tidy-text
              [body]="('Card ending in ' | translate) + item?.payment_method?.metadata?.last4" />
            @if (item?.payment_method?.is_primary) {
              <tidy-text
                [header]="'(primary)'"
                style="margin-left: 5px" />
            }
          }
          @if (item?.payment_method?.type === 'us_bank_account') {
            <tidy-text
              [body]="'Bank Account'" />
          }
        </tidy-row>
        @if (item?.payment_method?.metadata?.bank_name) {
          <tidy-row>
            <tidy-text
              [body]="item?.payment_method?.metadata?.bank_name + (item?.payment_method?.metadata?.account_type ? ' | ' + (item?.payment_method?.metadata?.account_type | translate) : '')" />
          </tidy-row>
        }
      }
      @if (!item?.isPendingClientCharge) {
        <tidy-row [alignLastItemRight]="true" [ngClass]="item?.refund_type ? '' : 'extra-bottom-padding'">
          <tidy-text
            style="margin-right:5px"
            [header]="(item?.amount | tcurrency) + ' ' + (item?.credit_type !== null ? (item?.credit_type | translate) : '')" />
          @if (item?.payment_method?.type === 'card') {
            <tidy-text
              [body]="('on card ' | translate) + item?.payment_method?.metadata?.last4" />
          }
          @if (item?.payment_method?.type === 'us_bank_account') {
            <tidy-text
              [body]="('on bank ' | translate) + (item?.payment_method?.metadata?.last4 ? (item?.payment_method?.metadata?.last4 | translate) : '')" />
          }
          @if (!hasProSelected && item?.credit_type !== 'credit') {
            <tidy-image
              style="margin-left: 5px; cursor: pointer"
              (action)="goToBillingItemHelp(item)"
              [src]="'assets/svg/help-circle-outline.svg'"
              class="header-size" />
          }
          <tidy-text
            [body]="item?.date | parseDateTime: 'MMM d'" />
        </tidy-row>
        @if (item?.refund_type) {
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [actionBody]="item?.refund_type"
              class="green" />
          </tidy-row>
        }
        @if (item?.added_by === 'cleaning' && item?.credit_type === 'credit') {
          <tidy-row [ngClass]="{'extra-bottom-padding': item?.details?.length > 0}">
            <tidy-text
              [body]="'Added from job on '" /><span>&nbsp;</span>
            <tidy-text
              [actionBody]="item?.source_cleaning_date | parseDateTime: 'MMM d'"
              (action)="goToCleaningDetails(item?.source_cleaning_id)"
              class="link" />
          </tidy-row>
        }
        @if (item?.added_by === 'concierge' && item?.credit_type === 'credit') {
          <tidy-row [ngClass]="{'extra-bottom-padding': item?.details?.length > 0}">
            <tidy-text
              [body]="'Added by '" /><span>&nbsp;</span>
            @if (item?.transferred_from) {
              <tidy-text
                [body]="item?.transferred_from?.account_name"
                [translate]="false" />
            }
            @if (!item?.transferred_from) {
              <tidy-text
                [body]="'Concierge'" />
            }
          </tidy-row>
        }
        @for (detail of item?.details; track detail; let i = $index; let last = $last) {
          <tidy-row [ngClass]="{'extra-bottom-padding': !last}">
            @if (detail?.debit_type !== 'refund') {
              <tidy-text
                [body]="detail?.amount_used | tcurrency" /><span>&nbsp;</span>
            }
            @if (detail?.debit_type !== 'refund') {
              <tidy-text
                [body]="' used'" />
            }
            @if (detail?.debit_type !== 'refund' && detail?.debit_source_billable_type !== 'Infrastructure::Models::Plan::SubscriptionInvoice') {
              @if (detail?.text_for_customer) {
                <tidy-text
                  [body]="' for '" /><span>&nbsp;</span>
                <tidy-text
                  [body]="detail?.text_for_customer"
                  [translate]="false" />
              }
              @if (!detail?.text_for_customer && !detail?.transferred_to) {
                <tidy-text
                  [body]="' by a '" /><span>&nbsp;</span>
                <tidy-text
                  [body]="detail?.cleaning_state | formatState" /><span>&nbsp;</span>
                <tidy-text
                  [body]="' job on '" /><span>&nbsp;</span>
                <tidy-text
                  [actionBody]="detail?.cleaning_date | parseDateTime: 'MMM d'"
                  (action)="goToCleaningDetails(detail?.cleaning_id)"
                  class="link" />
              }
              @if (!detail?.text_for_customer && detail?.transferred_to) {
                <tidy-text
                  [body]="' by'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="detail?.transferred_to?.team?.name"
                  (action)="changePro(detail?.transferred_to?.team?.owner_id)"
                  class="link"
                  [translate]="false" />
              }
            }
            @if (detail?.debit_source_billable_type === 'Infrastructure::Models::Plan::SubscriptionInvoice') {
              @if (detail?.debit_fee?.type === 'cleaning_completed_fee') {
                <tidy-text
                  [body]="' by a '" /><span>&nbsp;</span>
                <tidy-text
                  [body]="detail?.debit_fee?.fee_percentage" />
                @if (detail?.cleaning_date) {
                  <tidy-text
                    [body]="'% job fee for the '" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="detail?.cleaning_state | formatState" />
                  <tidy-text
                    [body]="' job on '" /><span>&nbsp;</span>
                  <tidy-text
                    [actionBody]="detail?.cleaning_date | parseDateTime: 'MMM d'"
                    (action)="goToCleaningDetails(detail?.cleaning_id)"
                    class="link" />
                } @else {
                  <tidy-text
                    [body]="'% job fee'" />
                }
              } @else {
                <tidy-text
                  [body]="' for '" /><span>&nbsp;</span>
                <tidy-text
                  [actionBody]="'your subscription'"
                  (action)="goToSubscriptionPage()"
                  class="link" />
                @if (detail?.text_for_customer) {
                  <span>&nbsp;</span>
                  <tidy-text
                    [body]="'(' + detail?.text_for_customer + ')'"
                    [translate]="false" />
                }
              }
            }
            @if (detail?.debit_type === 'debit' && (detail?.cleaning_state === 'cancelled' || detail?.cleaning_state === 'cancelled_once') && detail?.booking_id !== null) {
              <span>&nbsp;</span>
              <tidy-text
                [actionBody]="'Waive Fee'"
                (action)="waiveFee(detail?.booking_id)"
                class="link" />
            }
            @if (detail?.debit_type === 'refund') {
              <tidy-text
                [body]="detail?.amount_used | tcurrency" /><span>&nbsp;</span>
              <tidy-text
                [body]="' refunded. '" /><span>&nbsp;</span>
              <tidy-text
                [actionBody]="'Where is my refund?'"
                (action)="learnAboutRefund()"
                class="link" />
            }
          </tidy-row>
        }
      }
      @if (item?.credit_type === 'charge') {
        <tidy-card-button (action)="getRefund(item?.refundable)">
          <tidy-row class="vertical-align-center extra-top-padding">
            <tidy-image
              [src]="'assets/img/refund.svg'"
              class="header-size" />
            <tidy-text
              [body]="'Get Refund'" />
          </tidy-row>
        </tidy-card-button>
      }
      <tidy-card-button (action)="getHelp(item)">
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/img/question.svg'"
            class="header-size" />
          <tidy-text
            [body]="'Get Help'" />
        </tidy-row>
      </tidy-card-button>
    </tidy-card>

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
